"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var styles = function styles(theme) {
  return "\n  &.vds-divider--standard {\n    border-bottom: 0;\n    border-color: ".concat(theme && theme.vds && theme.vds.dividerStandard ? theme.vds.dividerStandard : "#d7d7de", ";\n    border-width: 1px;\n  }\n\n  &.vds-divider--section {\n    border-color: ").concat(theme && theme.vds && theme.vds.dividerSection ? theme.vds.dividerSection : "#2a2e69", ";\n    border-width: 1px;\n  }\n");
};

var _default = styles;
exports.default = _default;